module.exports = __webpack_public_path__ + "static/media/ProximaNovaFont.bf9f5d50.otf";